<template>
  <div>
    <div class="loading" v-if="loading" style="margin:50% 0;">
      <van-loading type="circular" color="#999"/>
    </div>
    <div v-if="!loading">
      <section>
        <header3 :back="newData.img" :desc="newData.summary" :title="newData.title"></header3>
      </section>
      <section>

        <div class="contents" style="background: #fff">
          <div class="list" v-for="(item,k) in newData.content" :key="k">
            <div class="title">{{ item.classify_name }}</div>
            <div class="photocentent">
              <news :newList="item.sub_news_list"></news>
            </div>
          </div>
        </div>


      </section>
      <footer1></footer1>
    </div>
  </div>
</template>

<script>
import header3 from '@/components/header3';
import news from '@/components/news2';
import footer1 from '@/components/footer';
import {getView} from "../commJs/api";
import { wechatShare } from "../commJs/wechat";

export default {
  data() {
    return {
      loading: true,

    }
  },
  components: {
    header3,
    footer1,
    news
  },
  methods: {
    getView(id) {
      getView({newsId: id}).then(res => {
        if (res.code == 200) {
          this.newData = res.data.news;
          this.loading = false
          document.title = res.data.news.title
          wechatShare(res.data.news.title);
        } else {
          this.errorT = res.msg
        }
      })
    },
    onClickLeft() {
      this.$router.go(-1)
    }
  },
  mounted() {
    this.id = this.$route.params.id || 0;
    if (!this.id || this.id == 0) {
      this.error = '该文章不存在'
    } else {
      this.getView(this.id)
    }
  }
}
</script>

<style scoped lang="less">
.contents {
  min-height: 60vh;
}

.photocentent {
  padding: 10px;
}

.title {
  padding: 10px;
  font-size: 18px;
  color: #3a60e1;
  font-weight: bold;
  border-bottom: 1px solid #eee;
  position: relative;
  padding-left: 20px;
  background: #eee;

  &:after {
    content: "";
    position: absolute;
    height: 15px;
    width: 2px;
    background: #3a60e1;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
  }
}
</style>